import axios from 'axios';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Proceeding, ProceedingRequest } from './ProceedingTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Proceeding>>('/author/proceedings/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Proceeding>(`/author/proceedings/${id}`).then(getData);
}

export function edit(id: Id, request: ProceedingRequest) {
  return axios.put<Proceeding>(`/author/proceedings/${id}`, request).then(getData);
}

export function create(request: ProceedingRequest) {
  return axios.post<Proceeding>(`/author/proceedings`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/proceedings/${id}`).then(getData);
}

export function addNewAlias(proceedingId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/proceedings/${proceedingId}/add-new-alias`, request).then(getData);
}
